import angular = require('angular');
import _ = require('underscore');
import { EnumService } from '../../../../app.common/modules/common/services/enum.service';
import { PopupService } from '../../../../app.common/modules/common/services/popup.service';
import { ClassificationCategoriesBase } from '../classification-categories-base.component';
import { ClassificationCategoriesService } from '../classification-categories.service';

class ClassificationCategories extends ClassificationCategoriesBase {
    public static $inject = ['classificationCategoriesService', 'popupService', '$timeout', 'enumService'];
    public languageId: number;

    constructor(
        classificationCategoriesService: ClassificationCategoriesService,
        popupService: PopupService,
        $timeout: ng.ITimeoutService,
        enumService: EnumService
    ) {
        super(classificationCategoriesService, popupService, $timeout, enumService);
    }

    public async getCategoriesTree() {
        return await this.classificationCategoriesService.getTree(this.languageId);
    }
}

angular
    .module('app.retailes.common')
    .component('classificationCategories', {
        template: require('./classification-categories.html'),
        controller: ClassificationCategories,
        controllerAs: 'vm',
        bindings: {
            selectedCategories: '=',
            businessType: '<',
            subcategoryId: '<',
            singleSelect: '<',
            waiting: '<',
            errors: '=',
            externalConfirm: '@',
            changeCategory: '&',
            hideTitles: '<',
            isDisabled: '<',
            languageId: '<'
        }
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/modules/categories/classification-categories/classification-categories.component.ts